import React from 'react'

import { Details, Row, Block } from '../details/details'
import { Collection, Group } from '../../components/details/collection'
import {
  DataCard,
  DataCardHeader,
  Details as DataCardDetails
} from '../data-card/data-card-parts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

const ServicingVersionCard = ({requestor, area, createdAt, redoReason, servicesString, id, removeServicing}) => (
  <DataCard style={{margin: '5px'}}>
    <DataCardDetails>
      <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between'}}>
        <h4 >{`Requested by ${requestor.name} on ${createdAt.format('h:mm a  MMM Do, YYYY')}`}</h4>
        <FontAwesomeIcon style={{cursor: 'pointer'}} size='lg' icon={faTimesCircle} color='red' onClick={(event) => removeServicing(id)} />
      </div>
      <div>{area.name}</div>
      <div>{servicesString}</div>
      <div>Redo reason: {redoReason}</div>
    </DataCardDetails>
  </DataCard>
)

export default ({
  locationModel,
  contract,
  servicingVersions,
  removeServicing
}) => {
  return (
    <div className="servicing-versions">
      <Details>
        <Row>
          <Block title='location'>
            <p>{locationModel && locationModel.name}</p>
          </Block>
          <Block title='contract' style={{ position: 'relative' }}>
            <p>{ contract &&
              `${contract.startDate.format('MMM Do, YYYY')} - ${contract.endDate.format('MMM Do, YYYY')}`}</p>
          </Block>
          <Block title='technician' style={{ position: 'relative' }}>
            <p>{servicingVersions[0] && servicingVersions[0].technician.name}</p>
          </Block>
        </Row>
        <Row>
          <strong style={{margin: '10px'}}>Total Corrective Action: {servicingVersions && servicingVersions.length}</strong>
        </Row>
      </Details>

      <Collection>
        <div className='list'>
          <Group title='corrective action' className='no-action'>
            {servicingVersions.map((version) => {
              let hash = {...version, removeServicing: removeServicing}
              return (<ServicingVersionCard key={version.id} {...hash} />)
            })}
          </Group>
        </div>
      </Collection>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-servicing-versions.js